export enum EInvitationStatus {
  Pending = 'PENDING',
  Accepted = 'Accepted',
  Rejected = 'Rejected',
  Expired = 'Expired',
}

export interface IBasicInvitationDetails {
  id: string;
  organization_id: string;
  email: string;
  invited_by: string;
  status: EInvitationStatus;
  created_at: string;
  updated_at: string;
}

export interface IInvitationDetails extends IBasicInvitationDetails {
  organization_name: string;
  is_account_exist: boolean;
  force_signup: boolean;
  role_id: string;
}
